export const Sources = Object.freeze({
    RDR: "Digital-RDR",
    PCB: "Digital-Pcb",
    AD_FUEL: "Digital-AF",
    GOOG_PPC: "Google-PPC",
    GOOG_RETARGET: "Google-RT"
});
